<template>
  <div class="house-info">
    <div class="house-info-context">
      <el-descriptions :column="1" direction="vertical" border>
        <el-descriptions-item label="项目信息">
          <el-descriptions title="" border :column="2">
            <el-descriptions-item label="上级">
              <el-select v-model="mainData.house_tree.parent_id" size="mini" filterable clearable>
                <el-option v-for="(item,index) in house_tree_list" :key="index" :label="item.ancestor_name" :value="item.house_id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="项目">
              <el-select v-model="mainData.house_tree.erp_pindex_id" size="mini" filterable disabled>
                <el-option v-for="(item,index) in project_list" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="名称">
              <el-input v-model="mainData.house_tree.house_name" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="等级">
              {{mainData.house_tree.level}}
            </el-descriptions-item>
            <el-descriptions-item label="类型">
              <el-select v-model="mainData.house_tree.type" size="mini">
                <el-option v-for="(item,index) in type_list" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-switch v-model="mainData.house_tree.show_status" :active-value="0" :inactive-value="1" size="mini"></el-switch>
            </el-descriptions-item>
            <el-descriptions-item label="完整房产">
              {{mainData.house_tree.ancestor_name}}
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
        <el-descriptions-item label="房产信息" v-if="mainData.house_tree.type!=88">
          <el-descriptions title="" border :column="2" v-if="mainData.house_tree.type!=88">
            <el-descriptions-item label="建筑面积">
              <el-input-number v-model="mainData.house.area" size="mini"></el-input-number>
            </el-descriptions-item>
            <el-descriptions-item label="套内面积">
              <el-input-number v-model="mainData.house.dwelling_space" size="mini"></el-input-number>
            </el-descriptions-item>
            <el-descriptions-item label="计费面积">
              <el-input-number v-model="mainData.house.charging" size="mini"></el-input-number>
            </el-descriptions-item>
            <el-descriptions-item label="花园面积">
              <el-input-number v-model="mainData.house.garden" size="mini"></el-input-number>
            </el-descriptions-item>
            <el-descriptions-item label="分摊面积">
              <el-input-number v-model="mainData.house.share" size="mini"></el-input-number>
            </el-descriptions-item>

            <el-descriptions-item label="楼层">
              <el-input-number v-model="mainData.house.BelongFloor" size="mini"></el-input-number>
            </el-descriptions-item>


            <el-descriptions-item label="停车场名称">
              <el-input v-model="mainData.house.parking_lot" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="车区编号">
              <el-input v-model="mainData.house.car_area_no" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="车位编号">
              <el-input v-model="mainData.house.parking" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="房态">
              <el-select size="mini" v-model="mainData.house.room_status" placeholder="房态">
                <el-option
                  v-for="item in room_status_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.code+''">
                </el-option>
              </el-select>
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="house-info-footer">
      <el-button type="primary" @click="clearData()">取 消</el-button>
      <el-button type="primary" @click="submitData()">保 存</el-button>
    </div>



  </div>
</template>

<script>
import Http from "../../../common/Http";

export default {
  name: "HouseTreeInfo",
  inject:['mainData'],
  data(){
    return{
      type_list:[
        {name:'住宅',value:1},
        {name:'车位',value:2},
        {name:'储藏室',value:3},
        {name:'商铺',value:4},
        {name:'写字楼',value:5},
        {name:'架构（区域/楼栋/单元/组团）',value:88},
      ],
      house_tree_list:[],
      project_list:[],
      room_status_list:[],
    }
  },
  mounted() {
    this.getHouseTree();
    this.getProjectList();
    this.getRoomStatusList();
  },
  methods:{
    getHouseTree() {
      const that = this;
      Http.get("HouseTree/getHouseTree",{project_id:that.mainData.house_tree.erp_pindex_id||89,is_tree:0},ret=>{
        if(ret.code){
          that.house_tree_list = ret.data;
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    getProjectList() {
      const that = this;
      Http.get("project/getProjectList",{},ret=>{
        if(ret.code){
          that.project_list = ret.data;
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    getRoomStatusList(){
      const that = this;
      Http.get("RoomStatus/getRoomStatusList",{},ret=>{
        if(ret.code){
          that.room_status_list = ret.data;
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    updateTree(){
      const that=this;
      let index=that.house_tree_list.findIndex(ret=>ret.house_id===that.mainData.house_tree.parent_id);
      if(index!==-1){
        let parent_house=that.house_tree_list[index];
        that.mainData.house_tree.parent_id=parent_house.house_id;
        that.mainData.house_tree.ancestor_ids=parent_house.ancestor_ids+","+(that.mainData.house_tree.house_id||0);
        that.mainData.house_tree.ancestor_name=parent_house.ancestor_name+"->"+(that.mainData.house_tree.house_name||'[未命名]');
        that.mainData.house_tree.deepest_node=0;

        if(that.mainData.house_tree.type!==88){
          that.mainData.house.pindex_id=that.mainData.house_tree.erp_pindex_id;
          that.mainData.house.type=that.mainData.house_tree.type;
          that.mainData.house.community_name=parent_house.house_name;
          that.mainData.house.address=that.mainData.house_tree.ancestor_name;
          that.mainData.house.xsc_HouseName=that.mainData.house_tree.ancestor_name;
          that.mainData.house_tree.deepest_node=1;
        }
        that.mainData.house_tree.level=that.mainData.house_tree.ancestor_ids.split(",").length;
      }
    },
    submitData(){
      const that=this;
      that.updateTree();
      Http.post("HouseTree/updateHouseTree",{
        house_tree:that.mainData.house_tree,
        house:that.mainData.house,
      },ret=>{
        if(ret.code){
          that.$message.success("保存成功");
          that.$emit("update");
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    clearData(){
      this.$emit("clear");
    }
  },
  watch:{
    "mainData.house_tree.parent_id":function (n,o) {
      this.updateTree()
    },
    "mainData.house_tree.house_name":function (n,o) {
      this.updateTree()
    },
    "mainData.house_tree.type":function (n,o) {
      this.updateTree()
    },
  }
}
</script>

<style lang="scss" scoped>
.house-info{
  .house-info-context{
    min-height: 50vh;
    max-height: 70vh;
    overflow-y: scroll;
  }
  .house-info-footer{
    padding: 5px;
    text-align: end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/components/HouseTreeInfo.vue